import { render, staticRenderFns } from "./CandidateComments.vue?vue&type=template&id=22c38768"
import script from "./CandidateComments.vue?vue&type=script&lang=js"
export * from "./CandidateComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c38768')) {
      api.createRecord('22c38768', component.options)
    } else {
      api.reload('22c38768', component.options)
    }
    module.hot.accept("./CandidateComments.vue?vue&type=template&id=22c38768", function () {
      api.rerender('22c38768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/CandidateComments.vue"
export default component.exports